/* Honey Glow, small behaviours for the hg-* sections.
   No dependencies. Works with the theme editor (re-inits on section load). */
(function () {
  'use strict';
  if (window.hgBaseLoaded) return;
  window.hgBaseLoaded = true;

  /* Tabs: [data-hg-tabs] > [role=tab][aria-controls] + [role=tabpanel] */
  function initTabs(root) {
    root.querySelectorAll('[data-hg-tabs]').forEach(function (tabs) {
      if (tabs.dataset.hgReady) return;
      tabs.dataset.hgReady = '1';
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      function select(btn) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { select(btn); });
        btn.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var next = buttons[(i + (e.key === 'ArrowRight' ? 1 : buttons.length - 1)) % buttons.length];
          select(next); next.focus();
        });
      });
    });
  }

  /* Product gallery: thumbs [data-hg-thumb=index] show [data-hg-slide=index] */
  function initGallery(root) {
    root.querySelectorAll('[data-hg-gallery]').forEach(function (gallery) {
      if (gallery.dataset.hgReady) return;
      gallery.dataset.hgReady = '1';
      var slides = gallery.querySelectorAll('[data-hg-slide]');
      var thumbs = gallery.querySelectorAll('[data-hg-thumb]');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.dataset.hgThumb;
          slides.forEach(function (s) {
            var on = s.dataset.hgSlide === idx;
            s.hidden = !on;
            if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
          });
          thumbs.forEach(function (t) { t.setAttribute('aria-current', t === thumb ? 'true' : 'false'); });
        });
      });
    });
  }

  /* Quantity steppers: [data-hg-qty] wraps an input[type=number] and two buttons */
  function initQty(root) {
    root.querySelectorAll('[data-hg-qty]').forEach(function (wrap) {
      if (wrap.dataset.hgReady) return;
      wrap.dataset.hgReady = '1';
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-hg-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, v + parseInt(btn.dataset.hgStep, 10));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* Video banner: play button swaps poster for the video kept in a <template> */
  function initVideo(root) {
    root.querySelectorAll('[data-hg-video]').forEach(function (box) {
      if (box.dataset.hgReady) return;
      box.dataset.hgReady = '1';
      var btn = box.querySelector('[data-hg-play]');
      var tpl = box.querySelector('template');
      if (!btn || !tpl) return;
      btn.addEventListener('click', function () {
        var holder = box.querySelector('[data-hg-video-holder]');
        holder.appendChild(tpl.content.cloneNode(true));
        holder.hidden = false;
        box.classList.add('is-playing');
        var v = holder.querySelector('video');
        if (v) v.play();
      });
    });
  }

  /* Product form: variant price, stock line, gift box add-on */
  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var comma = value.replace('.', ',');
    return (format || '€{{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function initProductForm(root) {
    root.querySelectorAll('[data-hg-product]').forEach(function (wrap) {
      if (wrap.dataset.hgReady) return;
      wrap.dataset.hgReady = '1';
      var form = wrap.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var dataEl = wrap.querySelector('[data-hg-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var format = wrap.dataset.moneyFormat;
      var select = form.querySelector('select[name="id"]');
      var priceEl = wrap.querySelector('[data-hg-price]');
      var compareEl = wrap.querySelector('[data-hg-compare]');
      var addBtn = form.querySelector('[data-hg-add]');

      if (select) {
        select.addEventListener('change', function () {
          var v = variants.find(function (x) { return String(x.id) === select.value; });
          if (!v) return;
          if (priceEl) priceEl.textContent = money(v.price, format);
          if (compareEl) {
            compareEl.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, format) : '';
          }
          if (addBtn) {
            addBtn.disabled = !v.available;
            addBtn.textContent = v.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSoldout;
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      }

      var gift = wrap.querySelector('[data-hg-gift]');
      var giftNote = wrap.querySelector('[data-hg-gift-note]');
      if (gift && giftNote) {
        gift.addEventListener('change', function () { giftNote.hidden = !gift.checked; });
      }

      form.addEventListener('submit', function (e) {
        if (!gift || !gift.checked || !gift.dataset.variant) return;
        e.preventDefault();
        var data = new FormData(form);
        var props = {};
        data.forEach(function (val, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && val) props[m[1]] = val;
        });
        var items = [
          { id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1), properties: props },
          { id: Number(gift.dataset.variant), quantity: 1 }
        ];
        if (addBtn) addBtn.disabled = true;
        fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart');
          window.location.href = wrap.dataset.cartUrl || '/cart';
        }).catch(function () {
          if (addBtn) addBtn.disabled = false;
          form.submit();
        });
      });
    });
  }

  /* Product recommendations: fetch the section rendered for this product */
  function initRecs(root) {
    root.querySelectorAll('[data-hg-recs]').forEach(function (box) {
      if (box.dataset.hgReady) return;
      box.dataset.hgReady = '1';
      fetch(box.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-hg-recs]');
          if (fresh && fresh.innerHTML.trim().length) box.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }


  /* Vertical reels: autoplay muted when visible, pause when out of view,
     play/pause and sound buttons, click-to-load for YouTube/Vimeo. */
  function initReels(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    root.querySelectorAll('[data-hg-reel]').forEach(function (reel) {
      if (reel.dataset.hgReady) return;
      reel.dataset.hgReady = '1';

      var ext = reel.querySelector('[data-hg-reel-external]');
      if (ext) {
        ext.addEventListener('click', function () {
          var tpl = reel.querySelector('template');
          if (tpl) reel.appendChild(tpl.content.cloneNode(true));
          ext.remove();
        });
        return;
      }

      var v = reel.querySelector('video');
      if (!v) return;
      var toggle = reel.querySelector('[data-hg-reel-toggle]');
      var sound = reel.querySelector('[data-hg-reel-sound]');
      v.muted = true;
      v.removeAttribute('controls');

      function sync() {
        var playing = !v.paused;
        reel.classList.toggle('is-playing', playing);
        reel.classList.toggle('is-unmuted', !v.muted);
        if (toggle) toggle.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
        if (sound) {
          sound.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
          sound.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        }
      }
      function play() { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }

      v.addEventListener('play', sync);
      v.addEventListener('pause', sync);
      v.addEventListener('volumechange', sync);

      if (toggle) toggle.addEventListener('click', function () {
        if (v.paused) { reel.dataset.userPaused = ''; play(); }
        else { reel.dataset.userPaused = '1'; v.pause(); }
      });
      if (sound) sound.addEventListener('click', function () {
        v.muted = !v.muted;
        if (!v.muted && v.paused) { reel.dataset.userPaused = ''; play(); }
      });

      if (reel.dataset.autoplay === 'true' && !reduce && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { if (!reel.dataset.userPaused) play(); }
            else if (!v.paused) { v.pause(); }
          });
        }, { threshold: 0.5 }).observe(reel);
      }
      sync();
    });
  }

  function init(root) {
    root = root || document;
    initTabs(root);
    initGallery(root);
    initQty(root);
    initVideo(root);
    initProductForm(root);
    initRecs(root);
    initReels(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
